import React, {Component} from 'react';

import ToggleInput from "../../../../../components/ToggleInput/toggleInput";
import formatters from "../../../../../utils/formatters";

export default class TripTruckEntry extends Component {

    render() {
        let trip = this.props.trip;
        if(!trip)return <div />;

        let controlText = 'Ingreso pendiente';
        let bannerColor = '';
        if(trip.reception_documentation_control_check){
            controlText = 'Ingreso aprobado';
            bannerColor = 'green-text';
        }else if(trip.reception_documentation_control_check === false){
            controlText = 'Ingreso rechazado';
            bannerColor = 'red-text';
        }

        let truck_entry_datetime = '-';
        if(trip.scale_in_datetime){
            truck_entry_datetime = formatters.datetimeFormat(trip.scale_in_datetime);
        }

        let form = (
            <div className={"row no-padding thin-row trip-form"}>
                <div className={"col s6 no-padding"}>
                    <div style={{height: 37, backgroundColor: '#d9d9d9', padding: 10}}>
                        <h4 className={'table-subtitle'}>Control de Ingreso</h4>
                    </div>
                    <div className={"row margin-top-10"}>
                        <div>
                            <div className={"col s6"}>
                                <ToggleInput selected={trip.reception_documentation_control_check }
                                             name={'Documentación camión'} />
                            </div>
                            <div className={"col s6"}>
                                <ToggleInput selected={trip.reception_documentation_control_check }
                                             name={'Documentación chofer'} />
                            </div>
                        </div>
                    </div>
                    <div className={"col s12"}>
                        <div className={`control-banner ${bannerColor}`}>
                            {controlText}
                        </div>
                    </div>
                </div>
                <div className={"col s6 no-padding"}>
                    <div style={{height: 37, backgroundColor: '#d9d9d9', padding: 10}}>
                        <h4 className={'table-subtitle'}>Balanza de Ingreso</h4>
                    </div>
                    <div className={"row no-margin margin-top-10"}>
                        <div style={{borderLeft: '1px solid #404040', paddingLeft: 20}}>
                            <div className={"row"}>
                                <div className={"col s6 input-field input-grey"}>
                                    <label className="active">Peso Ingreso</label>
                                    <p className={"field-p"}>{trip.entry_weight}</p>
                                </div>
                                <div className={"col s6 input-field input-grey"}>
                                    <label className="active">Balanza</label>
                                    <p className={"field-p"}>{trip.truck_scale.code}</p>
                                </div>
                            </div>
                            <div className={"row"}>
                                <div className={"col s12 input-field"}>
                                    <label className="active">Fecha / Hora Ingreso</label>
                                    <p className={"field-p"}>{truck_entry_datetime}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );

        if(this.props.boxed){
            return (
                <div className={"trip-section"}>
                    <div className={'trip-section-title'}>Ingreso a Terminal</div>
                    {form}
                </div>
            );
        }

        return form;
    }
}


// WEBPACK FOOTER //
// ./src/containers/Dashboard/InternalTrips/Trip/Done/TripTruckEntry.js